import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../list/ListHeader';
import TableUI from '../list/TableUI';
import HeaderViewList from '../list/HeaderViewList';
import FilterPannel from '../filter/FilterPannel';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import NoteAPI from '../../api/NoteAPI';
import KeyValueAPI from '../../api/KeyValueAPI';
import ViewController from "../../controller/ViewController";

class NoteList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    let filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.note;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Note);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.note ? cView.note : 0));
    if(!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.setList(filters);

    this.data = { notes: [], count: 0 };
    this.state = { massUpdate: false, massEmail: false, massSMS: false, inApiCall: true, isFilterOpen: false, popup: '' };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    
    this.selected = [];
  }

  componentDidMount() { if (this.List) this.loadNotes(); }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.note;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, note: lists };
    }

    const fields = [ "model", "type", "text", "created_date", "created_by", "updated_date", "updated_by" ];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, note: [...modelfields.note, this.list] };
    }
    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields 
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : { };
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'enquiry_date';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1; 

    if(this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ?  this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if(!field) {
        return false;
      }
      
      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  }

  saveListFilters = filters => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.note.find((item) => item.view === this.view.id);
    tmp.filters = filters;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  }

  saveListFields = fields => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.note.find((item) => item.view === this.view.id);
    tmp.fields = fields;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }

  savePerPage = perPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.note.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }

  savePageChange = currentPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.note.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  }
  
  loadNotes = () => {
    reactLocalStorage.setObject(Const.ListNote, this.list);
    const mainFilters = ViewController.getRestrictionsView(Const.Note);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true, popup: '' });
    NoteAPI.getList({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = res => this.setState({ ...this.state, inApiCall: false });
  onReceived = res => {
    this.data.notes = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  }

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.savePageChange(currentPage);
    this.loadNotes();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.savePerPage(perPage);
    this.loadNotes();
  }

  onFieldSelection = fields => {
    if(fields.includes('phone') && this.HideAllPhone) {
      fields = fields.splice(this.list.fields.indexOf('phone'), 1);
    }
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadNotes();
  }

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    this.saveListSort(this.list.sorting);
    this.loadNotes();
  }

  showMassUpdate = () => {
    if(this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please apply filters or Select Data', 'danger');
    } else this.setState({ ...this.state, massUpdate: !this.state.massUpdate });
  }
  showMassEmail = () => this.setState({ ...this.state, massEmail: !this.state.massEmail });
  showMassSMS = () => this.setState({ ...this.state, massSMS: !this.state.massSMS });

  showMassDelete = () => {
    if(this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please select notes', 'danger');
    } else {
      Util.confirmAlert('Delete', `Are you sure you want to mass delete (${this.selected.length}) notes ?`, 
        'Mass Delete', 'No', () => {
          this.setState({ ...this.state, inApiCall: true });
          NoteAPI.massDelete(this.list, this.selected, this.onMassDeleted, this.onFail);
        });
    }
  }
  onMassDeleted = () => {
    Util.showNotification('Successful', 'Note Mass Deleted successfull.', 'success');
    this.selected = [];
    this.loadNotes();
  }

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListNote, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  }

  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => {
    this.list.pagination.currentPage = 1;
    this.list.filters = filters;
    this.savePageChange(this.list.pagination.currentPage);
    this.saveListFilters(filters);
    this.loadNotes();
  };

  onPreview = index => {
    const note = this.data.notes[index];
    if(note.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${note.model_id}`);
    } else if(note.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${note.model_id}`);
    }
  }
  
  onSelect = id => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected});
  }
  onRemove = id => {
    this.selected = this.selected.filter(item => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected});
  }
  onSelectAll = () => {
    for(let i = 0; i < this.data.notes.length; i++) {
      const id = this.selected.find(item => item === this.data.notes[i].id);
      if(!id) this.selected.push(this.data.notes[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected});
  }
  onRemoveAll = () => {
    for(let i = 0; i < this.data.notes.length; i++) {
      this.selected = this.selected.filter(item => item !== this.data.notes[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected});
  }

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.note = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadNotes();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  render() {
    if(!this.List) return null;
    const fields = [ ...new Set(this.list.fields) ];
    return (
      <div>
        
        <HeaderViewList views={this.views} view={this.view} onTabClick={this.onTabClick} />

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
          update={this.update}
          showMassUpdate={this.showMassUpdate}
          showMassDelete={this.showMassDelete}
          showMassEmail={this.showMassEmail}
          showMassSMS={this.showMassSMS}
        />

        <div className="container-fluid">
          <div className="row">
            <TableUI
              data={this.data.notes}
              model={this.model}
              fields={fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={true}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange}
              isFilterOpen={this.state.isFilterOpen}
              findProperties={this.onProperties}
              selected={this.selected} onSelect={this.onSelect} onRemove={this.onRemove}
              onSelectAll={this.onSelectAll} onRemoveAll={this.onRemoveAll} 
              onCallClick={this.onCallClick} onMeetingClick={this.onMeetingClick}
            /> 

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              view={this.view}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(NoteList);